import React, { useEffect, useState } from "react";
import {
  useTheme,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Button,
  InputAdornment,
  Skeleton
} from "@mui/material";
import Fade from '@mui/material/Fade';
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tooltip from '@mui/material/Tooltip';
import baseURL from "../config";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from '@mui/icons-material/Search';
import CryptoJS from "crypto-js";
import RecordsTable from "../Components/RecordsTable";

const Offers = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filteredOfferData, setFilteredOfferData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const isNonMobile = useMediaQuery("(min-width:620px)");
  const [isLoading, setIsLoading] = useState(true);
  const [offerData, setOfferData] = useState({
    offerId: 0,
    startDate: "",
    endDate: "",
    description: "",
    content: "",
    image: "",
    brandId: "",
  });
  const [tabValue, setTabValue] = useState(0);
  const getDecryptedToken = () => {
    const encryptedToken = Cookies.get("token");
    if (!encryptedToken) return null;

    const secretKey = '19092002'; 
    const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedToken || null;
  };

 
  const token = getDecryptedToken();
  const [searchQuery, setSearchQuery] = useState("");

  const fetchOffers = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/Offers/GetAllOffers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        const offers = response.data.offers;
        setIsLoading(false);
        setFilteredOfferData(offers);
      } else {
        toast.error("Failed to fetch offers: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching offers data: ${error.message}`);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  
  const fetchOffer = async (offerId) => {
    try {
      const response = await axios.get(`${baseURL}/api/Offers/GetOfferById`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { id: offerId },
      });
      if (response.data.success) {
        setOfferData(response.data.offer);
        setDialogOpen(true);
      } else {
        toast.error("Failed to fetch offer: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching offer: ${error.message}`);
    }
  };


  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setOfferData((prevData) => ({
        ...prevData,
        image: reader.result.split(",")[1], // Base64 image
      }));
    };
    reader.readAsDataURL(file);
  };


  const handleEdit = (event) => {
    const { name, value } = event.target;
    setOfferData((prevData) => ({ ...prevData, [name]: value }));
  };


  const handleSave = async () => {
    if (!offerData.description || !offerData.startDate || !offerData.endDate || !offerData.content) {
      toast.error("Please fill in all fields.");
      return;
    }
 
    
    try {
      const response = await axios.post(
        `${baseURL}/api/Offers/UpdateOffer`,
        offerData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        toast.success("Oferta u përditësua me sukses!");
        await fetchOffers();
        setDialogOpen(false);
      } else {
        toast.error("Failed to update offer.");
      }
    } catch (error) {
      toast.error(`Error updating offer: ${error.message}`);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  }
  const filteredData = filteredOfferData.filter((offer) => {
    const description = offer.description?.toLowerCase() || ""; 
    const startDate = offer.startDate?.toLowerCase() || ""; 
    const endDate = offer.endDate?.toLowerCase() || ""; 
    const content = offer.content?.toLowerCase() || "";
  
    return (
      description.includes(searchQuery) ||
      startDate.includes(searchQuery) ||
      endDate.includes(searchQuery) ||
      content.includes(searchQuery)
    );
  });
  

  const desktopColumns = [
    {
      field: "offerId",
      headerName: "ID",
      flex: 0.35,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "startDate",
      headerName: "Start",
      flex: 0.9,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => (
        <span className="table-muted">{params.value ? new Date(params.value).toLocaleDateString() : "N/A"}</span>
      ),
    },
    {
      field: "endDate",
      headerName: "End",
      flex: 0.9,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => (
        <span className="table-muted">{params.value ? new Date(params.value).toLocaleDateString() : "N/A"}</span>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1.2,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "content",
      headerName: "Content",
      flex: 1.3,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-muted">{params.value || "N/A"}</span>,
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.35,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchOffer(params.row.offerId)}
          className="table-action-button"
          aria-label="Edit offer"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
      ),
    },
  ];

  const mobileColumns = [
    {
      field: "description",
      headerName: "Offer",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "endDate",
      headerName: "End",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => (
        <span className="table-muted">{params.value ? new Date(params.value).toLocaleDateString() : "N/A"}</span>
      ),
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.45,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchOffer(params.row.offerId)}
          className="table-action-button"
          aria-label="Edit offer"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
      ),
    },
  ];

  const columns = isNonMobile ? desktopColumns : mobileColumns
  return (
    <Box m="10px">
      <Header title="Ofertat" subtitle="Detajet e ofertave" />
      <ToastContainer />
      <Box mb={2} display="flex" justifyContent="flex-start">
        <TextField
          label="Search"
          variant="outlined"
          onChange={handleSearch}
          sx={{ backgroundColor: colors.primary[600], width: isNonMobile ? "30%" : "50%" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        
      <Link to="/offerForm" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.primary[700], marginLeft: "20px", marginTop: "8px"}}
        >
          Shto Oferta
        </Button>
      </Link>
      </Box>
        
      <Box
        m="10px 0 0 0"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: "#3b0a45" },
          "& .MuiDataGrid-columnHeaders": {
           background: "black",
            borderBottom: "none",
             color: "#ffffff"
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.primary[800],
            color: "#ffffff"
           
          },
          "& .MuiButton-root": { color: "#ffffff" },
          "& .super-app-theme--header": {
            backgroundColor: colors.primary[200],
          },
          "& .MuiToolbar-root":{color :"#ffffff"},
          "&. MuiTablePagination-actions": {color: "white"}

        }}
      >
      <div style={{ width: "100%" }}>

      {isLoading ? (
         
         <Skeleton
           variant="rectangular"
           width="100%"
           height={500}
           animation="wave"
         />
       ) : (
        <RecordsTable
          columns={columns}
          rows={filteredData}
          getRowId={(row) => row.offerId}
          onRowDoubleClick={(params) => fetchOffer(params.row.offerId)} 
          emptyMessage="No offers match your search."
        />
       )}
     </div>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        
        <DialogContent
            className="custom-dialog-size"
            sx={{ backgroundColor: colors.primary[500], height: isNonMobile ? "" : "50vh",}}
          >
            <div className="tabs-container">
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value = {tabValue}  
                >
                  <Tab
                    label="Info per Oferte"
                    sx={{
                      color: "white",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  </Tabs>
              </div>
              <div
                    style={{
                      margin: "10px",
                      textAlign: "center",
                      display: isNonMobile ? undefined : "flex",
                      flexDirection: isNonMobile ? "row" : "column",
                    }}
                  >

          
            <TextField
              label="Start Date"
              name="startDate"
              value={offerData.startDate}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="End Date"
              name="endDate"
              value={offerData.endDate}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Description"
              name="description"
              value={offerData.description}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Content"
              name="content"
              value={offerData.content}
              onChange={handleEdit}
              multiline
              fullWidth
              margin="dense"
            />
            <Box display="flex" alignItems="center" gap="10px">
              <TextField
                
                type="file"
                onChange={(e) => handleFileUpload(e.target.files[0])}
                fullWidth
                margin="dense"
                inputProps={{
                  accept: "image/*", // Ensures only image files can be selected
                }}
              />
              <Tooltip title="Image should be 771x170 for the best quality" arrow>
              <IconButton>
                  <i className="fas fa-info-circle" style={{ color: colors.primary[900] }}></i>
                </IconButton>
              </Tooltip>
            </Box>
          </div>
        <DialogActions className="custom-dialog-background">
                <Button
                  onClick={() => setDialogOpen(false)}
                  sx={{ backgroundColor: "white" }}
                  >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  sx={{ backgroundColor: "white" }}
                  >
                  Save
                </Button>
              </DialogActions>
               </DialogContent>    
                </Dialog>
      </Box>
    </Box>
  );
};

export default Offers;
